import clsx from "clsx";

export interface YearFilterBarProps {
  years: number[];
  activeYear: number;
  onChange: (year: number) => void;
  /** Optional: Jahre die als historisch gekennzeichnet werden sollen */
  historicalYears?: ReadonlySet<number> | number[];
}

export function YearFilterBar({
  years,
  activeYear,
  onChange,
  historicalYears,
}: YearFilterBarProps) {
  if (!years.length) return null;
  const sorted = [...years].sort((a, b) => b - a);
  const histSet =
    historicalYears instanceof Set
      ? historicalYears
      : new Set(historicalYears ?? []);

  return (
    <div className="flex flex-wrap gap-2" role="tablist" aria-label="Jahr filtern">
      {sorted.map((year) => {
        const historisch = histSet.has(year);
        return (
          <button
            key={year}
            type="button"
            role="tab"
            aria-selected={year === activeYear}
            className={clsx(
              "rounded-full px-3 py-1 text-sm font-medium transition",
              year === activeYear
                ? "bg-accent text-white"
                : "bg-fill-tertiary text-label-secondary hover:bg-fill-secondary hover:text-label",
            )}
            onClick={() => onChange(year)}
          >
            {year}
            {historisch ? (
              <span
                className={clsx(
                  "ml-1 text-[10px] font-normal uppercase tracking-wide",
                  year === activeYear ? "text-white/80" : "text-label-tertiary",
                )}
              >
                hist.
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
